export default "__VITE_ASSET__09ed9ed9__"